import { Banner, Col, Row, Typography } from 'darrius';

import { HowMuchData } from '../../../data/home/homeData';

import styles from './HowMuch.module.scss';

export const HowMuch = () => {
  return (
    <Banner as="section" className={styles['how-much']}>
      <Col className="col-sm-12">
        <Row className="middle-sm space-bottom space-between">
          <Col className="col-sm-12 col-md-2 hide-mobile">
            <img
              src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/partner-money-package.svg`}
              alt="Icone pacote de moedas"
            />
          </Col>
          <Col className="col-sm-12 col-md-5">
            <Typography.Title size="3xl">{HowMuchData.title}</Typography.Title>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 20,
              }}
            >
              <Typography.Text>
                No GetNinjas não tem mensalidade e nem custo para se cadastrar.
              </Typography.Text>

              <Typography.Text className="mt">
                Você investe em um <strong>pacote de moedas</strong> dentro da
                plataforma para liberar o acesso ao contato do cliente e fica
                com
                <strong> 100% do valor negociado!</strong>
              </Typography.Text>
            </div>
          </Col>

          <Col className="col-sm-12 col-md-5 center-sm">
            <img
              src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/partner-how-much.svg`}
              alt="Icone quanto custa"
            />
          </Col>
        </Row>
      </Col>
    </Banner>
  );
};
